import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import { TextArea } from '../../components/Inputs/TextArea'
import Button from '../../components/General/Button'
import { IFoodTable } from 'safe'
import Select from '../../components/Inputs/Select'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const WaiterForm: React.FC<WaiterFormProps> = ({
  onSubmit,
  onClose,
  useType,
  isLoading,
  defaultValues,
}) => {
  const { addAlert } = useSnackBars()
  const [alreadyExists, setAlreadyExists] = useState<boolean>(false)

  const form = useForm<any>({
    defaultValues: {
      realName: defaultValues?.realName || '',
      email: defaultValues?.email || '',
      enabled: defaultValues?.enabled || false,
      password: defaultValues?.password || '',
      password2: defaultValues?.password2 || '',
    },
  })

  let status = [
    {
      value: 'true',
      text: 'Habilitado',
    },
    {
      value: 'false',
      text: 'Inhabilitado',
    },
  ]

  const getEnabled = () => {
    return useType === 'edit' || useType === 'watch' ? status.find((v) => v?.value === defaultValues?.enabled + '') : status[0]
  }

  const onSubmitForm = (values) => {

    if (values?.realName?.trim() !== values?.realName) {
      form?.setError('realName', {
        type: 'manual',
        message: 'El nombre no debe tener espacios',
      })
      return
    }

    if(values?.password?.trim() !== values?.password) {
      form?.setError('password', {
        type: 'manual',
        message: 'La contraseña no debe tener espacios',
      })
      return
    }

    if (values.email.trim() !== values.email) {
      form?.setError('email', {
        type: 'manual',
        message: 'El correo no debe tener espacios',
      })
      return
    }
    if (alreadyExists) {
      addAlert({
        message: 'Correo ya existente',
        status: 'error',
      })
      return
    }

    if (values.password !== values.password2) {
      addAlert({
        message: 'Las contraseñas no coinciden',
        status: 'error',
      })
      return
    }
    onSubmit(values)

  }

  return (
    <Form classes="grid grid-cols-12 gap-4" form={form} onSubmit={onSubmitForm}>
      <div className="col-span-12">
        <h1 className="text-2xl font-bold">
          {useType === 'watch'
            ? 'Ver Mesonero'
            : useType === 'edit'
            ? 'Editar Mesonero'
            : 'Crear Mesonero'}
        </h1>
      </div>

      <FormItem
        name="realName"
        classes="col-span-12"
        rules={{ required: 'Es necesario el nombre' }}
      >
        <InputText disableInput={useType !== 'create'} small label="Nombre" />
      </FormItem>

      <FormItem
        name="email"
        classes="col-span-12"
        rules={{
          required: 'Es necesario el correo',
          pattern: {
            value: /^[^\s\\/]+@[^\s\\/]+\.[^\s\\/]+$/,
            message:
              'El correo no debe contener espacios ni caracteres especiales',
          },
          // validate: (value) => {
          //   console.log('value probando...', value)
          //   if (value.trim() !== value) {
          //     console.log('value...', value)
          //     return 'El correo no debe contener espacios al inicio o al final'
          //   }
          //   return true
          // }
        }}
      >
        <InputText disableInput={useType !== 'create'} small label="Correo" />
      </FormItem>

      <FormItem name="enabled" defaultValue={getEnabled()} classes="col-span-12">
        <Select
          disabled={useType === 'watch'}
          options={status}
          setSelectedHelper={async (v) => {}}
          label="Estado"
        />
      </FormItem>

      { useType === 'create' && (
          <FormItem
          name="password"
          classes="col-span-12"
          rules={{ 
            required: 'Es necesario la contraseña',
            pattern: {
              value: /^[a-zA-Z0-9@#$%!^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/,
              message: 'Caracteres no válidos'
            }
          }}
        >
          <InputText small label="Contraseña" password />
        </FormItem>
  
      ) }

      { useType === 'create' && (
        <FormItem
          name="password2"
          classes="col-span-12"
          rules={{ required: 'Es necesario la contraseña' }}
        >
          <InputText small label="Confirmar contraseña" password />
        </FormItem>
      ) }


      {useType !== 'watch' && (
        <div className="flex col-span-12 gap-3">
          <Button
            type="outline"
            classes="w-1/2"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>

          <Button
            type="primary"
            classes="w-1/2"
            htmlType="submit"
            loading={isLoading}
            disabled={isLoading}
          >
            {useType === 'create' ? 'Añadir' : 'Guardar cambios'}
          </Button>
        </div>
      )}
    </Form>
  )
}

export default WaiterForm

interface WaiterFormProps {
  onSubmit: (data: any) => void
  onClose: () => void
  useType?: 'create' | 'edit' | 'watch'
  isLoading?: boolean
  defaultValues?: any
}
